import { motion } from 'framer-motion'
import { CaretLeft, CaretRight } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useNavigate, useParams } from 'react-router-dom'
import { DialogModal } from '../../components/DialogModal'
import { Medias } from '../../enumns/medias'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { fetchProjectById } from '../../services/hooks/projects/queries/useProjectQuery'
import { useTaskSearchQuery } from '../../services/hooks/tasks/queries/useTaskQuery'
import { type ProjectDomain } from '../../types/domain/project-domain'
import { type TaskDomain } from '../../types/domain/task-domain'
import { type TaskSearchDomain } from '../../types/domain/task-search-domain'
import { TaskForm } from './Projects/components/TaskForm/TaskForm'

export const TaskList = () => {
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false)
  const [selectedTask, setSelectedTask] = useState<TaskDomain>()
  const [selectedProject, setSelectedProject] = useState<ProjectDomain>()
  const isMinScreenWidthLG = useMediaQuery(`(min-width: ${Medias.LG}px)`)
  const navigate = useNavigate()
  const { term } = useParams()
  const { data, refetch } = useTaskSearchQuery({ search: term })

  useEffect(() => {
    refetch()
  }, [term])

  const handleNavigateToProject = (project: TaskSearchDomain) => {
    project.project_is_filed
      ? navigate(`/painel/projects/archived/${project.project_id}`)
      : navigate(`/painel/projects/${project.project_id}`)
  }

  const closeTaskModal = () => {
    setIsTaskModalOpen(false)
    setSelectedTask(undefined)
  }

  const handleOpenTaskModal = async (projectId: number, taskId: number) => {
    const project = await fetchProjectById(projectId)
    setSelectedProject(project)
    const task = project.tasks?.find((task) => task.id === taskId)
    setSelectedTask(task)
    setIsTaskModalOpen(true)
  }

  return (
    <>
      <div className="relative p-6 flex flex-col">
        <header className="flex flex-col px-6 mb-6 lg:flex-row lg:justify-between">
          <div className="flex items-center justify-between mb-4 lg:gap-3 lg:flex-row lg:mb-0">
            <h1 className="text-base font-normal lg:text-lg text-grey-900 ">
              {data?.length === 0
                ? 'Nenhum resultado encontrado para: '
                : 'Resultados para: '}
              <span className="font-medium text-primary-light">"{term}"</span>
            </h1>
          </div>
        </header>

        {data?.map((project) => (
          <div key={project.project_id} className="p-6">
            <div className="flex">
              <h1 className="font-semibold">{project.project_name}</h1>
              <button
                className="mb-5 text-grey-700"
                onClick={() => handleNavigateToProject(project)}
              >
                <CaretRight className="ml-2" size={24} />
              </button>
            </div>
            {project.tasks?.map((task) => (
              <div
                key={task.task_id}
                className="flex justify-between items-center p-5 gap-2.5 w-full h-14 mb-2 rounded-lg bg-grey-100"
              >
                <span className="font-normal">{task.task_name}</span>
                <button
                  className="text-grey-700"
                  onClick={() =>
                    handleOpenTaskModal(project.project_id, task.task_id)
                  }
                >
                  <CaretRight className="ml-2" size={24} />
                </button>
              </div>
            ))}
          </div>
        ))}
      </div>
      {/* Create Task Modal */}
      {isMinScreenWidthLG && selectedProject ? (
        <DialogModal
          isOpen={isTaskModalOpen}
          title={selectedProject.name}
          onClose={closeTaskModal}
          styleBox={{ maxWidth: '1300px' }}
        >
          <TaskForm
            selectedTask={selectedTask}
            project={selectedProject}
            onClose={closeTaskModal}
          />
        </DialogModal>
      ) : (
        <>
          {isTaskModalOpen &&
            selectedProject &&
            createPortal(
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed top-0 bottom-0 left-0 right-0 z-50 p-6 overflow-y-auto bg-white scrollbar"
              >
                <button
                  aria-label="Voltar"
                  className="mb-8"
                  onClick={() => {
                    setIsTaskModalOpen(false)
                    document.body.style.overflow = 'auto'
                  }}
                >
                  <CaretLeft size={24} className="text-grey-700" />
                </button>

                <TaskForm
                  selectedTask={selectedTask}
                  project={selectedProject}
                  onClose={closeTaskModal}
                />
              </motion.div>,
              document.body
            )}
        </>
      )}
    </>
  )
}
